import React from "react";
import { motion } from "framer-motion";
import { MaskLine } from "./motion";

export default function PageHero({ eyebrow, title, accent, subtitle, testid }) {
  return (
    <section data-testid={testid} className="relative pt-36 pb-14 sm:pb-20 border-b border-border overflow-hidden">
      <div className="absolute inset-0 footprint-bg opacity-[0.04] pointer-events-none" aria-hidden="true" />
      <div className="relative max-w-[1400px] mx-auto px-5 sm:px-8">
        {eyebrow && <p className="font-accent text-chick text-2xl sm:text-3xl mb-2">{eyebrow}</p>}
        <h1 className="font-heading uppercase tracking-tighter leading-[0.85] text-5xl sm:text-7xl lg:text-8xl">
          <MaskLine delay={0.1}>
            {title} {accent && <span className="text-orange">{accent}</span>}
          </MaskLine>
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="text-cream/70 text-lg max-w-2xl mt-5"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
